import { HttpRestService } from "@/services/http/HttpRestService";

export class ConferenciaDeBaiaRepository {
  static build() {
    return new ConferenciaDeBaiaRepository();
  }

  getPedidoPerVolume(volumeId) {
    return HttpRestService.get(`/api/v2/volume/detalhes/${volumeId}`);
  }

  postConfirmErrorPedido(volumeId) {
    return HttpRestService.post(
      `/api/v2/triagem/confirmar-error-triagem/${volumeId}/volume`
    );
  }
}
